import { render } from "./BusinessList.vue?vue&type=template&id=ff97626e"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__